angular.module('LeasePilot').factory('UsersService', [
  'railsResourceFactory',
  function(railsResourceFactory) {
    return railsResourceFactory({
      url: '/api/users',
      name: 'user',
    });
  },
]);
